// extracted by mini-css-extract-plugin
export default {"pasture":"pasture_pasture__zqAU5","UI":"pasture_UI__uFmcZ","fence":"pasture_fence__-WWqG"};